import { camelizeKeys } from 'humps';
import { socketSend } from '@namespace/socket';
import {
  API_SOCKET_ENDPOINT,
  commandsActionsMap,
  commandsMap
} from '../../constants';
import { mutateLimit } from './utils/mutateLimit';

export const setLimit = (type, payload) =>
  mutateLimit(type, {
    ...payload,
    type: commandsActionsMap[type].set
  });

export const cancelLimit = (type, payload) =>
  mutateLimit(type, {
    ...payload,
    type: commandsActionsMap[type].reset
  });

export const initLimit = async (type) => {
  const response = await socketSend({
    cmd: API_SOCKET_ENDPOINT,
    data: {
      query: {
        [commandsMap[type]]: {}
      }
    }
  });

  const result = camelizeKeys(response.data);

  return result[type];
};
